import { Language, Message } from "@lango/api/src/types";
import React from "react";

import { UserTextMessage } from "./UserTextMessage/UserTextMessage";
import { UserErrorMessage } from "./UserErrorMessage/UserErrorMessage";
import { BotTextMessage } from "./BotTextMessage/BotTextMessage";
import { UserHintsMessage } from "./UserHintsMessage/UserHintsMessage";

type Props = {
  data: Message;
  onPlayText?: (text: string) => void;
  onWordPress?: (word: string, language: Language) => void;
  onGrammarReview?: () => void;
  onRetry?: () => void;
  onTranslation?: (messageId: string, translation: string) => void;
};

export const ChatMessage: React.FC<Props> = ({
  data,
  onPlayText,
  onRetry,
  onWordPress,
  onGrammarReview,
  onTranslation,
}) => {
  if (data.sender === "user") {
    if (data.messageType === "text") {
      if (!onPlayText) {
        throw new Error("onPlayText is required");
      }
      return (
        <UserTextMessage
          data={data}
          onPlayText={onPlayText}
          onGrammarReview={onGrammarReview}
        />
      );
    }
    if (data.messageType === "error") {
      if (!onRetry) {
        throw new Error("onRetry is required");
      }

      return (
        <UserErrorMessage
          description="Connection problem, tab to retry."
          onClick={onRetry}
        >
          {data.text}
        </UserErrorMessage>
      );
    }
    if (data.messageType === "hint") {
      if (!onPlayText) {
        throw new Error("onPlayText is required");
      }
      return <UserHintsMessage data={data} onPlayText={onPlayText} />;
    }

    throw new Error("Unknown message type");
  }

  if (data.messageType === "text") {
    if (!onPlayText) {
      throw new Error("onPlayText is required");
    }
    if (!onWordPress) {
      throw new Error("onWordPress is required");
    }
    return (
      <BotTextMessage
        data={data}
        onPlayText={onPlayText}
        onWordPress={onWordPress}
        onTranslation={onTranslation}
      />
    );
  }

  throw new Error("Unknown message type");
};
